import React from "react";
const Logo = () => {
  return (
    <svg
      width="192"
      height="192"
      viewBox="0 0 192 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="carafin-logo">
        <path
          id="carafin-logo__left"
          d="M104.985 120.206L28.9853 158.424C15.6847 165.113 0 155.444 0 140.556V68.6623C0 61.1034 4.26157 54.1903 11.0147 50.7943L87.0147 12.576C100.315 5.88741 116 15.5562 116 30.4439V102.338C116 109.897 111.738 116.81 104.985 120.206Z"
          fill="url(#paint0_linear_39_2)"
        />
        <path
          id="carafin-logo__right"
          d="M104.985 12.576L180.985 50.7943C187.738 54.1903 192 61.1034 192 68.6623V140.556C192 155.444 176.315 165.113 163.015 158.424L87.0147 120.206C80.2616 116.81 76 109.897 76 102.338V30.4439C76 15.5562 91.6847 5.88742 104.985 12.576Z"
          fill="url(#paint1_linear_39_2)"
        />
        <path
          id="carafin-logo__face"
          d="M159.043 102.999L104.269 76.2779C98.7347 73.578 92.2653 73.578 86.731 76.2779L31.9573 102.999C18.6257 109.502 16.7646 127.746 28.5084 136.808L83.282 179.072C90.4804 184.627 100.52 184.627 107.718 179.072L162.492 136.808C174.235 127.746 172.374 109.502 159.043 102.999Z"
          fill="url(#paint2_radial_39_2)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_39_2"
          x1="105.531"
          y1="20.6415"
          x2="23.4385"
          y2="149.202"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8F5FE6" />
          <stop offset="1" stopColor="#483072" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_39_2"
          x1="176.064"
          y1="146.266"
          x2="98.2838"
          y2="22.9136"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#286EFA" />
          <stop offset="1" stopColor="#123375" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_39_2"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(95.5 73.1469) rotate(90) scale(108.138 92.5)"
        >
          <stop stopColor="#ED4DEA" />
          <stop offset="1" stopColor="#892C88" />
        </radialGradient>
      </defs>
    </svg>
  );
};
export default Logo;
